export enum CalculationPayOutType {
    STAIRCASE = 'staircase',
}
